import { useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Progress } from "@/components/ui/progress";
import { Dropzone } from "@/components/converter/Dropzone";
import { FileQueue } from "@/components/converter/FileQueue";
import { API } from "@/lib/api";
import { filesForm, useFileQueue } from "@/lib/files";

export const AddFilesDialog = ({ open, onOpenChange, jobId, onStarted }) => {
  const { queue, addFiles, removeAt, clear } = useFileQueue();
  const [pct, setPct] = useState(null);

  const start = async () => {
    setPct(0);
    try {
      await axios.post(`${API}/jobs/${jobId}/append`, filesForm(queue), {
        onUploadProgress: (ev) => ev.total && setPct(Math.round((ev.loaded / ev.total) * 100)),
      });
      toast.success(`${queue.length} file in conversione: i movimenti verranno aggiunti alla tabella.`);
      clear();
      onOpenChange(false);
      onStarted();
    } catch (e) {
      toast.error(e.response?.data?.detail || "Caricamento non riuscito, riprova.");
    } finally {
      setPct(null);
    }
  };

  return (
    <Dialog open={open} onOpenChange={(v) => pct === null && onOpenChange(v)}>
      <DialogContent data-testid="add-files-dialog" className="max-h-[90vh] max-w-2xl overflow-y-auto">
        <DialogHeader>
          <DialogTitle className="font-display">Aggiungi movimenti</DialogTitle>
          <DialogDescription>
            Scegli altri estratti conto PDF: verranno letti con l'OCR e i movimenti si aggiungeranno a quelli già presenti, ordinati per data.
          </DialogDescription>
        </DialogHeader>
        <Dropzone onFile={addFiles} compact />
        {queue.length > 0 && (
          <FileQueue files={queue} onRemove={removeAt} onClear={clear} onStart={start} busy={pct !== null}
            startLabel={`Converti e aggiungi ${queue.length} file`} />
        )}
        {pct !== null && (
          <div data-testid="add-files-upload-progress" className="space-y-2">
            <Progress value={pct} className="h-2 bg-slate-100" />
            <p className="font-mono text-xs text-slate-500">Caricamento file: {pct}%</p>
          </div>
        )}
      </DialogContent>
    </Dialog>
  );
};
